export const bio = {
  name: 'Michel Rico',
  role: { fr: 'Sculpteur', en: 'Sculptor' },
  text: {
    fr: [
      "Né en 1946 à Biarritz, j’ai poursuivi une carrière de sculpteur toute ma vie.",
      "J’ai 13 ans quand, à Dieulefit, je découvre le travail du métal, une rencontre décisive pour tout mon parcours, avec un matériau que je n’ai plus jamais quitté : d’abord l’acier, puis le bronze.",
      "Je présente mon travail depuis 1975, lors d’expositions personnelles et collectives, en galeries, salons parisiens, musées, tant en France qu’à l’étranger.",
      "J’ai créé un certain nombre d’œuvres monumentales pour des commandes publiques et des collectionneurs privés. En parallèle, j’ai fait de nombreuses créations pour des sociétés. Mes sculptures sont réparties dans le monde entier.",
      "Jusqu’en 1997, j’étais installé sur l’Ile Saint-Germain à Issy-les-Moulineaux, où j’avais construit mon atelier dans lequel je disposais de ma propre fonderie. [[DESKTOP_BREAK]]Depuis, j’ai réinstallé mes ateliers et ma galerie d’exposition à 80 km au sud de Paris, où je travaille aujourd’hui.",
      "Je vous y accueillerais avec plaisir, sur rendez-vous.",
    ],
    en: [
      "Born in Biarritz, France, in 1946, I have pursued a lifelong career as a sculptor.",
      "At the age of 13, in Dieulefit, I discovered metalwork. It was a decisive moment that shaped my life's work. I began with steel and later turned to bronze.",
      "Since 1975, my work has been shown in solo and group exhibitions in galleries, Paris salons, and museums, in France and abroad.",
      "I have created monumental works for public commissions and private collectors, alongside numerous pieces for corporate clients. My sculptures are represented around the world.",
      "Until 1997, I was based on the Île Saint-Germain in Issy-les-Moulineaux, where I built my studio and operated my own foundry. Since then, I have re-established my studio and gallery 80 km south of Paris, where I work today.",
      "I would be delighted to meet you there, by appointment."
    ],
  },
  portrait: './images/bio/portrait.jpg',
  workshopImages: [
    './images/bio/Fonderie_Ambiance_Atelier_1.jpeg',
    './images/bio/Fonderie_Ambiance_Atelier_2.jpeg',
    './images/bio/Fonderie_Ambiance_Atelier_3.jpeg',
  ],
  contact: {
    address: '2 petite rue Sourde,\n45390 Echilleuses, France',
    email: 'ricomichel@orange.fr',
    phone: '+ 33 (0)6 37 28 60 93',
  },
};
